import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';
import { getOptions } from '@ourbranch/lookups';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import { tooltipHoverTexts } from 'core/helpers/constants';

const ArkansasAutoLimits = ({ id, disabled, UMBIOptions, UIMBIOptions, UMPDOptions }) => {
  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Uninsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      <Grid item xs={6}>
        <LabelTooltip
          label="Underinsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUIMBI`}
            id={`${id}.policyLimitUIMBI`}
            type="select"
            options={UIMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>
      <Grid item xs={6}>
        <LabelTooltip
          label="Un/Underinsured Motorist PD"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimPropertyDamage }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMPD`}
            id={`${id}.policyLimitUMPD`}
            type="select"
            options={UMPDOptions}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
      <Grid item xs={6}>
        <LabelTooltip
          label="Personal Injury Protection"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.personalInjuryProtection }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitPIP`}
            id={`${id}.policyLimitPIP`}
            type="select"
            options={getOptions('policyLimitPIP', 'AR')}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
    </>
  );
};

ArkansasAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired,
  UIMBIOptions: PropTypes.array.isRequired
};

ArkansasAutoLimits.defaultProps = {
  disabled: false
};

export default connect(ArkansasAutoLimits);
